import React from 'react';
import Nabvar from '../Components/Navbar/Navbar'
import { Outlet } from 'react-router-dom';
import Footer from '../Components/Footer/Footer'
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../Components/Cart/Cart'
import TitleMeta from '../Components/TitleMeta/TitleMeta';
export default function IndexLayout() {

    return (
        <div className='pages-layout'>
            <TitleMeta />
            
            <Outlet />
            <Footer/>
            <BtnWhatsapp />
            <Cart />
            <div className='espaciobg2'>

            </div>

        </div>
    );
}
